import { AppState } from '@/store/state';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { allShopProductDetails } from '@pages/modal/allShopProductDetails';
import { shopDetails } from '@pages/modal/shopdetails';
import { AppService } from '@services/app.service';
import { Subject, takeUntil, of } from 'rxjs';
import { productDetails } from "@pages/modal/productdetails";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { data } from "browserslist";
import { ProductService } from "@services/Product.Service";
import { ShopProductDetails } from "@pages/modal/shopProductDetails/ShopProductDetails";
import { MainCategory } from "@pages/modal/mainCategory";
import { catchError, finalize } from "rxjs/operators";


@Component({
    selector: 'my-shop-product',
    templateUrl: './my-shop-product.component.html',
    styleUrls: ['./my-shop-product.component.scss']
})
export class MyShopProductComponent implements OnInit {
    searchText;
    destroy$: Subject<boolean> = new Subject<boolean>();
    shopList: shopDetails[] = [];
    localShopList: shopDetails[] = [];
    shopProductList: allShopProductDetails[] = [];
    shopBasedProductList: ShopProductDetails[] = [];
    getAllActiveShopProducts: ShopProductDetails[] = [];
    activeShopProducts: ShopProductDetails[] = [];
    productDetails: productDetails[] = [];
    showShopName: String[] = [];
    shopName: string;
    productName: string = "";
    editModal: boolean = false;
    selectedShopId: string = "";
    mainCategoryMap!: Map<number, string>
    subCategoryMap!: Map<number, string>
    selectedCateGoryName: string = "";
    selectSubCateGoryName: string = "";
    categoryNameList: String[] = [];
    subCategoryNameList: String[] = [];
    isCategoryEnabled: boolean = false;
    isSubCategoryEnabled: boolean = false;

    constructor(private renderer: Renderer2, private store: Store<AppState>,
        private appService: AppService, private router: Router,
        private spinner: NgxSpinnerService, private toaster: ToastrService,
        private productService: ProductService) {
    }

    ngOnInit(): void {
        this.mainCategoryMap = new Map<number, string>();
        this.subCategoryMap = new Map<number, string>();
        this.getAllMainCategory()
        this.getShopDetails();

    }

    updateButtonShow(product: allShopProductDetails) {
        product.isUpdateEnabled = true;
    }


    getShopDetails() {
        this.spinner.show();
        this.appService.getShopDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide();
                console.log("Shop Details::", data);
                this.shopList = data;
                if (this.shopList.length === 1) {
                    this.selectedShopId = String(this.shopList[0].traderId);
                    this.selectAllProduct({ target: { value: this.selectedShopId } }); // Call the method manually
                }
            },
                (error: any) => {
                    this.spinner.hide();
                    this.toaster.error("Something went wrong for get Shop Details")
                })
    }


    selectAllProduct(event) {
        this.activeShopProducts = [];
        this.shopBasedProductList = [];
        const value = event.target.value;
        this.selectedShopId = value;
        this.selectedCateGoryName = "";
        this.selectSubCateGoryName = "";
        this.isCategoryEnabled = true;
        this.isSubCategoryEnabled = false;
        this.getActiveProduct(value);
    }

    getActiveProduct(value: any): void {
        this.spinner.show();
        this.appService
            .getShopProductDetails(value)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.spinner.hide()), // Always hide spinner
                catchError((error) => {
                    console.error("Error fetching shop product details:", error);
                    this.toaster.error("Failed to load product details. Please try again.");
                    return of([]);
                })
            )
            .subscribe((data: ShopProductDetails[]) => {
                console.log("Trader ID based product show::", data);
                this.shopBasedProductList = data;

                for (let shop of this.shopBasedProductList) {
                    shop.catName = this.mainCategoryMap.get(shop.mainProductCategoryId);
                    shop.subCatName = this.subCategoryMap.get(shop.subProductCategoryId);
                }

                this.getAllActiveShopProducts = this.shopBasedProductList.sort(
                    (a, b) => b.shopProductId - a.shopProductId
                );
                this.categoryNameList = Array.from(new Set(this.getAllActiveShopProducts.map(item => item.catName)));
                this.activeShopProducts = this.getAllActiveShopProducts;
                console.log("active shop list::", this.activeShopProducts);
            });
    }

selectCatList(event: any) {
    const selectedCategory = event.target.value;
    this.selectedCateGoryName = selectedCategory;
    this.selectSubCateGoryName = "";
    this.isSubCategoryEnabled = true;

    this.subCategoryNameList = Array.from(new Set(
        this.getAllActiveShopProducts
            .filter(p => p.catName === selectedCategory)
            .map(p => p.subCatName)
    ));

    this.filterProducts();
}

selectSubCatList(event: any) {
    this.selectSubCateGoryName = event.target.value;
    this.filterProducts();
}

filterProducts() {
  const filterVale = this.getAllActiveShopProducts.filter(product => {
    const matchCategory = !this.selectedCateGoryName || product.catName === this.selectedCateGoryName;
    const matchSubCategory = !this.selectSubCateGoryName || product.subCatName === this.selectSubCateGoryName;
    return matchCategory && matchSubCategory;
  });

  this.activeShopProducts = filterVale;
}

clearFilters() {
    this.selectedCateGoryName = "";
    this.selectSubCateGoryName = "";
    this.isSubCategoryEnabled = false;

    this.activeShopProducts = [...this.getAllActiveShopProducts];
}

    updateSRP(productSRP, productMRP, productId) {
        this.spinner.show();
        console.log("SRP::", productSRP);
        console.log("MRP::", productMRP);
        console.log("productId", productId)
        this.appService
            .updateProduct(productId, productMRP, productSRP)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide()
                this.toaster.success("price updated successfully");
                console.log("Update SRP::", data)
                this.getActiveProduct(this.selectedShopId);
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error(error.error.msg || 'Failed to update the price')
            })
    }


    editProduct(product: allShopProductDetails) {
        console.log(`shop product ID::`, product);
        this.productService.setProductId(product.shopProductId);
        this.router.navigate(['/main/product-inclusion']);
    }

    getAllMainCategory() {
        this.spinner.show();
        this.appService
            .getCategory()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("Product values::", data);
                for (let category of data) {
                    this.mainCategoryMap.set(category.catId, category.catName);
                }
                this.getAllSubCategory();
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error(error.error.msg || "Something went wrong for get products")
            });
    }


    getAllSubCategory() {
        this.spinner.show();

        this.appService.getAllSubCategory()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log("Product values::", data);
                    for (let sub of data) {
                        this.subCategoryMap.set(sub.subCatId, sub.subCatName);
                    }
                    this.spinner.hide(); // ✅ hide spinner on success
                },
                error: (error: any) => {
                    this.spinner.hide(); // ✅ always hide spinner on error too
                    this.toaster.error(error?.error?.msg || "Something went wrong while fetching sub-categories");
                }
            });
    }


    getCategoryName(catId: number): string {
        return this.mainCategoryMap[catId];
    }

    getSubCategoryName(subCatId: number): string {
        return this.subCategoryMap[subCatId];
    }


    updateStatus(shopProductId: number, status: 'Active' | 'InActive') {

        const productStatus = {
            shopProductId: shopProductId,
            status: status
        }

        this.spinner.show();
        this.appService.updateShopProductStatus(productStatus)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log("Update status::", data);
                    this.toaster.success('Product status updated successfully');
                    this.spinner.hide();
                    const product = this.activeShopProducts.find(p => p.shopProductId === shopProductId);
                    if (product) product.status = status;
                },
                error: (error: any) => {
                    this.spinner.hide();
                    this.toaster.error(error?.error?.msg || "Something went wrong while update product status");
                }
            });
    }
}
